import request from "@/router/axios";
export const getAuthResource = () => {
  return request({
    url: `/api/jc/resource/getAuthResource`,
    method: "get",
  });
};
export const recommend = (billId) => {
  return request({
    url: `/api/api/jc/recommend`,
    method: "get",
    params: {
      billId,
    },
  });
};
export const oneReserve = (billIds) => {
  return request({
    url: `/api/jc/bill/oneReserve`,
    method: "post",
    params: {
      billIds,
    },
  });
};
export const reserve = (data) => {
  return request({
    url: `/api/api/jc/reserve`,
    method: "post",
    data: data,
  });
};
export const change = (data) => {
  return request({
    url: `/api/api/jc/change`,
    method: "post",
    data: data,
  });
};
export const sign = (data) => {
  return request({
    url: `/api/api/jc/sign`,
    method: "post",
    data: data,
  });
};
export const billDetail = (billId) => {
  return request({
    url: `/api/api/jc/billDetail`,
    method: "get",
    params: {
      billId,
    },
  });
};
export const cancel = (data) => {
  return request({
    url: `/api/api/jc/cancel`,
    method: "post",
    data: data,
  });
};
export const syncBills = () => {
  return request({
    url: `/api/api/jc/task/syncBills`,
    method: "post",
  });
};
export const getSchedules = (billId) => {
  return request({
    url: `/api/jc/bill/getSchedules`,
    method: "get",
    params: {
      billId,
    },
  });
};
export const getNote = (projectId, partName) => {
  return request({
    url: `/api/jc/notes/getNote`,
    method: "get",
    params: {
      projectId: projectId,
      partName: partName,
    },
  });
};

export const getBillsSchedule = (billIds) => {
  return request({
    url: `/api/jc/bill/getBillsSchedule`,
    method: "get",
    params: {
      billIds: billIds,
    },
  });
};
export const reserveChange = (data) => {
  return request({
    url: `/api/api/jc/reserveChange`,
    method: "post",
    data: data,
  });
};
export const getResSchedulesOfDate = (resId, date) => {
  return request({
    url: `/api/api/jc/schedule/getResSchedulesOfDate`,
    method: "get",
    params: {
      resId,
      date,
    },
  });
};
